<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="proId"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" label="一起行产品ID" v-bind="formItemLayout">
        <a-input v-model="queryParams.productId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName" label="产品名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.productName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
        <a-button style="margin-left:15px" @click="visible = true">手动同步</a-button>
      </a-form-item>
      <div slot="catalogId" slot-scope="rowItem">{{ rowItem.record.catalogId|productTypeName }}</div>
      <div slot="action" slot-scope="data">
        <a @click="onPreview(data.record)">预览</a>
      </div>
    </search-page-view>
    <a-modal title="手动同步" :width="800" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="同步规则" required>
          <a-radio-group v-model="form.syncType">
            <a-radio :value="1">全部同步</a-radio>
            <a-radio :value="2">指定产品同步</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="一起行产品ID：" prop="productIds" v-if="form.syncType == 2">
          <a-textarea style="width:430px;" v-model="form.productIds" :rows="6"
                      placeholder="请输入一起行产品ID，一行一个，最多20个">
          </a-textarea>
        </a-form-model-item>
      </a-form-model>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
      </a-form-model-item>
    </a-modal>
  </a-card>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'SynchronousProducts',
  data() {
    return {
      submitLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId
      },
      visible: false,
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '一起行ID',
          dataIndex: 'proProductUrl',
          width: '15%'
        },
        {
          title: '产品名称',
          dataIndex: 'proName',
          width: '30%'
        },
        {
          title: '类型',
          dataIndex: 'catalogId',
          scopedSlots: { customRender: 'catalogId' }
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '80px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      form: {
        syncType: 1
      },
      rules: {
        productIds: [
          { required: true, message: '请输入一起行产品ID', trigger: 'blur' },
          { validator: this.checkProIdStr, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SynchronousProducts', title: '同步产品' },
      { name: 'DirectOrdersList', title: '订单直连' },
      { name: 'TogetherAccount', title: '关联账号' }
    ])
  },
  methods: {
    checkProIdStr(rule, value, callback) {
      if (value.split(/\r?\n/).length > 20) {
        callback(new Error('票付通商品ID最多20个'))
      } else {
        callback()
      }
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    onPreview(record) {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.proId, record.catalogId, 0, params)
    },
    submitEvent() {
      let url = ''
      let params = {}
      if (this.form.syncType === 1) {
        url = 'travel/auto/sync'
      } else {
        url = 'travel/manual/sync'
        params.productIds = this.form.productIds
      }
      this.submitLoading = true
      this.getHttpServices().getProService().post(url, params).then(res => {
        this.$message.success('保存成功')
        this.visible = false
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      }).finally(() => this.submitLoading = false)
    },
    handleCancel() {
      this.visible = false
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('travel/product/all', params)
    }
  }
}
</script>

<style scoped>

</style>